import React from "react";
import { concatStringFromClassesArrayList } from "../Utils/StringUtils";

interface Props {
  classes?: string;
  height?: string;
  width?: string;
  viewBox?: string;
  dataTestId?: string;
  style?: React.CSSProperties;
  focusable?: boolean;
  preserveAspectRatio?: string;
  children: React.ReactNode; // SVG content passed as children
}

export interface IconProps {
  classes?: string;
  style?: React.CSSProperties;
}

export const Icon = ({
  classes,
  height,
  width,
  viewBox,
  dataTestId,
  style,
  focusable,
  preserveAspectRatio,
  children,
}: Props) => {
  const classList = {
    defaultClass: "ons-icon",
    optionalClasses: [classes || null],
  };

  const className: string = concatStringFromClassesArrayList(classList);

  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      height={height}
      width={width}
      viewBox={viewBox}
      data-testid={dataTestId}
      style={style}
      focusable={focusable}
      preserveAspectRatio={preserveAspectRatio}
      role="img"
      fill="currentColor"
    >
      {children}
    </svg>
  );
};
